import React from "react";
import PropTypes from "prop-types";

import Box from "../box/index.js";
import styles from "./styles.module.scss";

const Table = ({ background = "none", columns = [], rows = [] }) => {
  return (
    <Box
      background={background}
      className={styles.table}
      corners="rounded"
      element="table"
      width="full"
    >
      {columns.length > 0 && (
        <Box element="thead" profiling="borderless" width="auto">
          <Box element="tr" profiling="borderless" width="auto">
            {columns.map((column, index) => (
              <Box element="th" key={index}>
                {column}
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {rows.length > 0 && (
        <Box element="tbody" profiling="borderless" width="auto">
          {rows.map((row, index) => (
            <Box element="tr" key={index} profiling="borderless" width="auto">
              {row.map((column, index) => (
                <Box element="td" key={index}>
                  {column}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

Table.propTypes = {
  background: PropTypes.oneOf(["none", "noise"]),
  columns: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.arrayOf(PropTypes.array)
};

export default Table;
